import React, { useState } from 'react';
import { useAct, gsap, prefersReduced } from '../hooks/useScrollStory';

/* ══════════════════════════════════════════════════════
   SSS — sık sorulan sorular (açılır-kapanır)
   Tıklayınca cevap yumuşakça açılıyor. Tek seferde bir
   soru açık; tekrar tıklayınca kapanıyor.
   ══════════════════════════════════════════════════════ */

const FAQ = [
  {
    q: 'Agren AI nedir?',
    a: 'Agren AI; bitki analizi, tarla verileri, uydu görüşü ve yapay zekâ asistanını tek uygulamada birleştiren bir akıllı tarım uygulamasıdır. Amacı, çiftçinin günlük tarım kararlarını daha düzenli, anlaşılır ve veriye dayalı hâle getirmek.',
  },
  {
    q: 'Uygulamayı nasıl indiririm?',
    a: 'Şu an Android cihazlarda kullanılabiliyor. Sayfadaki “Uygulamayı İndir” butonuna dokunarak indirme sayfasına ulaşabilirsin.',
  },
  {
    q: 'Hastalık analizi kesin teşhis veriyor mu?',
    a: 'Hayır. Agren AI, fotoğraf üzerindeki belirtileri inceleyerek olası nedenler hakkında bir ön değerlendirme sunar. Kesin karar için saha gözlemi ve gerektiğinde uzman görüşü esastır.',
  },
  {
    q: 'Uydu ve tarla verileri ne işe yarar?',
    a: 'Tarlanı farklı zamanlarda karşılaştırıp dikkat edilmesi gereken bölgeleri daha kolay fark etmeni sağlar. Renkli analiz haritaları her zaman saha gözlemiyle birlikte değerlendirilmelidir.',
  },
  {
    q: 'Tarım asistanına ne sorabilirim?',
    a: 'Bitki bakımı, tarla yönetimi, hava koşulları ve günlük üretim kararları gibi tarımla ilgili sorularını sorabilirsin. Yanıtlar, sorunu tarla bağlamında değerlendirerek verilir.',
  },
  {
    q: 'Agren AI ziraat mühendisinin yerini alır mı?',
    a: 'Hayır. Senin yerine karar vermez; tarlanı daha erken ve daha bilinçli anlamana yardımcı olan bir asistandır. Son karar her zaman senindir.',
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  const ref = useAct((root) => {
    const q = gsap.utils.selector(root);
    if (prefersReduced()) return;
    gsap.from(q('.faq-reveal'), {
      opacity: 0, y: 30, ease: 'power3.out', duration: 0.6, stagger: 0.07,
      scrollTrigger: { trigger: root, start: 'top 76%' },
    });
  }, []);

  return (
    <section ref={ref} id="sss" className="relative overflow-hidden" style={{ background: '#050605' }}>
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true"
        style={{ background: 'radial-gradient(ellipse 55% 45% at 50% 8%, rgba(200,255,34,.07) 0%, rgba(200,255,34,0) 60%)' }} />

      <div className="relative max-w-[820px] mx-auto px-6 md:px-10 py-[clamp(80px,13vh,140px)]">
        <div className="faq-reveal text-center mb-[clamp(36px,5vh,56px)]">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/12 bg-white/[0.03] px-4 py-1.5 font-mono text-[11.5px] tracking-[.2em] uppercase" style={{ color: '#C8FF22' }}>
            <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: '#C8FF22', boxShadow: '0 0 10px #C8FF22' }} />
            SSS
          </span>
          <h2 className="mt-6 font-display font-bold text-white leading-[1.05] tracking-[-0.03em]" style={{ fontSize: 'clamp(28px,3.6vw,48px)' }}>
            Sık sorulan sorular
          </h2>
        </div>

        <div className="faq-reveal space-y-3">
          {FAQ.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className="rounded-2xl border overflow-hidden transition-colors duration-300"
                style={{ borderColor: isOpen ? 'rgba(200,255,34,.28)' : 'rgba(255,255,255,.1)', background: 'rgba(255,255,255,.02)' }}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5"
                >
                  <span className="font-display font-semibold text-white" style={{ fontSize: 'clamp(16px,1.7vw,19px)' }}>{item.q}</span>
                  <span className="shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-full border transition-all duration-300"
                    style={{ borderColor: isOpen ? 'rgba(200,255,34,.5)' : 'rgba(255,255,255,.18)', color: isOpen ? '#C8FF22' : '#F7F7F2', transform: isOpen ? 'rotate(45deg)' : 'none' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
                  </span>
                </button>
                <div style={{ display: 'grid', gridTemplateRows: isOpen ? '1fr' : '0fr', transition: 'grid-template-rows .35s ease' }}>
                  <div style={{ overflow: 'hidden' }}>
                    <p className="px-5 md:px-6 pb-6 -mt-1 text-[15px] leading-relaxed text-white/60">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
